import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioLiftDecomposition } from "./constants";
import type { DecisioningStudioLiftDecompositionParams, DecisioningStudioLiftDecompositionResult } from "./types";
import { isDecisioningStudioLiftDecompositionResult } from "./validators";

export const getDecisioningStudioLiftDecomposition = reactQueryFetcherAdapter(
  decisioningStudioLiftDecomposition,
  (
    signal: AbortSignal,
    { appGroupId, dsaId, environment }: DecisioningStudioLiftDecompositionParams
  ): Promise<DecisioningStudioLiftDecompositionResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/insights/lift_decomposition`,
      "GET",
      { environment },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isDecisioningStudioLiftDecompositionResult
);
